import React, { useState } from 'react';
import TypeableSelect from '../../components/Dropdowns/TypeableSelect';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { chatbotResponsesUpsert, getChatbotResponses } from '../../store/actions/tenantAction';
import { CHATBOT_BLOCK_TYPES } from '../../utils/ChatbotBlockTypes';
import { getVariableComponent } from '../../utils/TemplateHelper';

function CopyChatbotBlock({ setIsShow, onAdd, selectedBlock, allIntent }) {
    const { t } = useTranslation();
    let dispatch = useDispatch();
    const [selectedIntent, setSelectedIntent] = useState({});
    const globalReducer = useSelector((state) => state.globalReducer);

    const onConfirm = () => {
        if (selectedIntent?.id) {
            dispatch(getChatbotResponses(
                {
                    tenantId: globalReducer.loginInfo?.tenantId,
                    criteria: {
                        tenantWabaId: globalReducer.waba?.id,
                        id: selectedIntent?.id,
                    }
                }, async (d) => {
                    if (d?.data[0]?.responses && d?.data[0]?.responses.length > 0) {
                        if (selectedBlock?.type === CHATBOT_BLOCK_TYPES.WHATSAPP_TEMPLATE) {
                            const componentsVal = await getVariableComponent(dispatch, globalReducer.loginInfo, globalReducer.waba, selectedBlock?.template, selectedBlock?.template?.carouselTemplate, true);
                            if (componentsVal) {
                                selectedBlock.templateValue = { components: componentsVal };
                            }
                        }
                        d?.data[0]?.responses.push(JSON.stringify(selectedBlock));
                        dispatch(chatbotResponsesUpsert(d?.data[0], (a) => {
                            setIsShow(false);
                            onAdd(a);
                        }));
                    }
                }
            ));
        }
    }

    return (
        <div className='px-8 py-4'>
            <TypeableSelect height={"37px"} list={allIntent} selected={selectedIntent} selectedValueField="intentName" labelField="intentName" valueField="intentName" placeholder={t("Select Action Intent")} onSelect={(s) => {
                setSelectedIntent(s);
            }} />
            <div className='flex justify-end mt-4 gap-2'>
                <button type='button' className="justify-center items-center flex min-w-[100px] px-2 h-10 py-1 font-semibold text-[14px] text-white bg-theme rounded cursor-pointer" onClick={() => setIsShow(false)}>
                    {t("Cancel")}
                </button>
                <button type='button' className="justify-center items-center flex min-w-[100px] px-2 h-10 py-1 font-semibold text-[14px] text-white bg-theme rounded cursor-pointer" onClick={onConfirm}>
                    {t("Confirm")}
                </button>
            </div>
        </div>
    )
}

export default CopyChatbotBlock